/**
 * Resolve a task's room name from the family's room list.
 *
 * Tasks only carry `room_id` from the Supabase backend; the old Express API also sent a joined
 * `room_name`, which AdminPanel kept reading after the migration — so admin task cards always
 * showed "No room". Look the name up by id instead, like the member views do.
 */
/** The task's room (name + optional picture), or null. */
export function getRoom<R extends { id: string; name: string; image_url?: string | null }>(
  rooms: ReadonlyArray<R> | null | undefined,
  roomId: string | null | undefined,
): R | null {
  if (!roomId || !rooms?.length) return null;
  return rooms.find((r) => r.id === roomId) || null;
}

export function getRoomName(
  rooms: ReadonlyArray<{ id: string; name: string }> | null | undefined,
  roomId: string | null | undefined,
): string | null {
  if (!roomId || !rooms?.length) return null;
  return rooms.find((r) => r.id === roomId)?.name || null;
}
